export const booths = [
    {
        name: "LangChain",
        link: "https://www.langchain.com/",
        description: "LangChain is an open-source software development framework centered around composability, designed to make it easier to create applications that leverage large language models (LLMs). LangChain was launched back in October 2022 as an open-source project by Harrison Chase.",
        image: require("../../assets/images/sponsors/langchain.png")
    },
    {
        name: "Glean",
        link: "https://www.glean.com/",
        description: "The world's most advanced AI platform for the enterprise. Powerful deep learning models understand user's company's information and users' queries. User's unique enterprise knowledge graph understands people, content, and interactions. Connect to all enterprise knowledge and enforce the existing permissions of user's data sources.",
        image: require("../../assets/images/sponsors/glean.svg").default
    },
    {
        name: "Arize AI",
        link: "https://arize.com/",
        description: "Arize is the machine learning observability platform for ML practitioners to monitor, troubleshoot, and explain models. Data Science and ML Engineering teams of all sizes (from individuals to enterprises) can use Arize to: Evaluate, monitor, and troubleshoot LLM applications; Monitor real-time model performance, with support for delayed ground truth/feedback; Root cause model failures/performance degradation using tracing and explain ability; Conduct multi-model performance comparisons; Surface drift, data quality, and model fairness/bias metrics.",
        image: require("../../assets/images/sponsors/arize.svg").default
    },
    {
        name: "Microsoft",
        link: "https://www.microsoft.com/en-us/?ql=4",
        description: "Microsoft Corporation is an American multinational technology corporation headquartered in Redmond, Washington.  Microsoft's best-known software products are the Windows line of operating systems, the Microsoft 365 suite of productivity applications, and the Internet Explorer and Edge web browsers.  Its flagship hardware products are the Xbox video game consoles and the Microsoft Surface lineup of touchscreen personal computers.",
        image: require("../../assets/images/sponsors/microsoft.png")
    },
    {
        name: "Vicuna",
        link: "https://lmsys.org/blog/2023-03-30-vicuna/",
        description: "Vicuna-13B is an open-source chatbot trained by fine-tuning LLaMA on user-shared conversations collected from ShareGPT. Preliminary evaluation using GPT-4 as a judge shows Vicuna-13B achieves more than 90% quality of OpenAI ChatGPT and Google Bard while outperforming other models like LLaMA and Stanford Alpaca in more than 90% of cases.  The code and weights, along with an online demo, are publicly available for non-commercial use.",
        image: require("../../assets/images/sponsors/vicuna.png")
    },
    {
        name: "LIamaIndex",
        link: "https://huggingface.co/llamaindex",
        description: "LlamaIndex provides a complete toolkit to build language-based applications. On top of that, users can use various data loaders and agent tools from Llama Hub to develop complex applications with multiple functionalities. Users can also connect custom data sources to their LLM with one or more plugins Data Loaders.",
        image: require("../../assets/images/sponsors/llamaindex.png")
    },
    {
        name: "WorldCoin",
        link: "https://worldcoin.org/",
        description: "Worldcoin is an open-source protocol, supported by a global community of developers, individuals, economists and technologists committed to expanding participation in, and access to, the global economy. The Worldcoin Foundation is the steward, and will support and grow the Worldcoin community until it becomes self-sufficient. Tools for Humanity helped launch Worldcoin, and currently serve as advisors to the Foundation and operators of the World App.",
        image: require("../../assets/images/sponsors/worldcoin.png")
    },
    {
        name: "Tencent",
        link: "https://www.tencent.com/",
        description: "",
        image: require("../../assets/images/sponsors/tencent.png")
    },
    {
        name: "Llama 2",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/llama2.png")
    },
    {
        name: "DeepBrain AI",
        link: "https://www.deepbrain.io/",
        description: "DeepBrain AI uses virtual humans and generative AI to automate job interviews. DeepBrain AI Ltd., a South Korean video synthesis startup that creates artificial intelligence-based virtual humans, they announced a new capability called AI Interview that can automate job applicant interviews for recruiters.",
        image: require("../../assets/images/sponsors/deepbrain.png")
    },
    {
        name: "Lepton AI",
        link: "https://www.lepton.ai/",
        description: "Lepton AI allows developers and enterprises to deploy AI applications swiftly and at scale. With its Python-native design, users can build models without diving into containers or Kubernetes, test them locally, and deploy to the cloud with one command. Its versatile API ensures easy integration into any application, and it supports optimal hardware choices and horizontal scaling for larger workloads.",
        image: require("../../assets/images/sponsors/lepton.png")
    },
    {
        name: "RealChar",
        link: "https://realchar.ai/",
        description: "With RealChar, users can create, customize and talk to their AI Character/Companion in Realtime (All in One Codebase). Have a natural seamless conversation with AI everywhere through mobile, web and terminal using LLM OpenAI GPT3.5/4, Anthropic Claude2, Chroma Vector DB, Whisper Speech2Text, ElevenLabs Text2Speech.",
        image: require("../../assets/images/sponsors/realchar.png")
    },
    {
        name: "Perplexity AI",
        link: "https://www.perplexity.ai/",
        description: "Perplexity AI is designed as an integration of a search engine and a chatbot. Its user interface is not only dedicated to delivering precise search results but also emphasizes presenting information from authoritative and reliable sources. Through this platform, users can conveniently access and interactively explore information, ensuring that the content they receive is both accurate and trustworthy.",
        image: require("../../assets/images/sponsors/perplexity.png")
    },
    // {
    //     name: "Cerebral Valley",
    //     link: "https://cerebralvalley.ai/",
    //     description: "Cerebral Valley is a community comprised of founders and builders, dedicated to collaboratively researching and crafting the next generation of technology. Within this valley, members share resources, experiences, and knowledge, fostering cooperation and communication to push the boundaries of technological innovation.",
    //     image: require("../../assets/images/sponsors/cerebral.png")
    // },
    // {
    //     name: "Founders Space",
    //     link: "https://www.foundersspace.com/",
    //     description: "Founders Space is a global innovation hub for entrepreneurs, corporations, and investors, with over 50 partners in 22 countries. Founders Space is a global venture builder and innovation hub. Founders Space has been ranked as # 1 by Forbes and Entrepreneur Magazines because of their unique venture building model and global reach.",
    //     image: require("../../assets/images/sponsors/founderspace.png")
    // },
    {
        name: "MountainLion",
        link: "https://test.mountainlion.ai/#/",
        description: "MountainLion is an AI cryptocurrency investment analysis tool incubated by GPTDAO. By integrating advanced artificial intelligence technologies, it offers investors unprecedented depth and breadth of analysis in the cryptocurrency domain. With MountainLion, investors can effortlessly explore intricate market data. Its robust data analysis capabilities enable it to identify subtle shifts in the market and provide users with timely feedback.",
        image: require("../../assets/images/sponsors/mountainlion.png")
    },
    {
        name: "Starloom",
        link: "https://starloom.ai/#/",
        description: "Starloom is an advanced AI fortune-telling platform incubated by GPTDAO, dedicated to offering users accurate and real-time divination services. By integrating ancient wisdom such as astrology, the art of naming, the 'Eight Characters' of horoscope birth data, and Zhou Gong's dream interpretation, and merging it with the latest cutting-edge artificial intelligence technologies, Starloom enables users to gain deeper insights into their potential fortunes.",
        image: require("../../assets/images/sponsors/starloom.png")
    },
    {
        name: "1Gen.ai",
        link: "https://1gen.ai/",
        description: "With 1Gen.ai, users can effortlessly generate animated images using natural language, indulging in a seamless journey of image editing and creative design. This tool integrates advanced controllable AI technology, offering users revolutionary innovation in image creation and design.",
        image: require("../../assets/images/sponsors/1gen.jpeg")
    },
    {
        name: "Arcticeider",
        link: "",
        description: "With 1Gen.ai, users can effortlessly generate animated images using natural language, indulging in a seamless journey of image editing and creative design. This tool integrates advanced controllable AI technology, offering users revolutionary innovation in image creation and design.",
        image: require("../../assets/images/sponsors/Arcti.png")
    },
    {
        name: "MetaBlox",
        link: "https://metablox.io/",
        description: "MetaBlox is delivering enterprise-grade WiFi roaming to the public worldwide, ensuring uninterrupted, low-cost access to Web3 and the Metaverse compared to cellular services, as well as enhanced network security and an exceptional overall experience.",
        image: require("../../assets/images/sponsors/metablox.png")
    },
    {
        name: "MetaGPT",
        link: "https://github.com/geekan/MetaGPT",
        description: "The Multi-Agent Framework: Given one line Requirement, return PRD, Design, Tasks, Repo.",
        image: require("../../assets/images/sponsors/metagpt.png")
    },
    {
        name: "sineaptic",
        link: "https://sineaptic.com/",
        description: "",
        image: require("../../assets/images/sponsors/sineaptic.avif")
    },
    {
        name: "CitingAI",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/citingAI.png")
    },
    {
        name: "ExaBITS",
        link: "https://www.exabits.ai/",
        description: "ExaBITS's mission is to streamline GenAI experiences by reducing costs, saving time, and enhancing the quality of life for users. Their vision is to create a dynamic digital ecosystem where users actively participate and benefit from their contributions. By providing computing resources, training LLM, generating content, and sharing data, users become integral parts of the ExaBITS network. ExaBITS envisions a future where knowledge and resources are shared freely, fostering an open, friendly, and collaborative environment.",
        image: require("../../assets/images/sponsors/ExaBITS.png")
    },
    // {
    //     name: "Norbert",
    //     link: "",
    //     description: "Norbert is a specialized data startup for GenAI applications. It provides high quality labeling at low cost. It supports many types of applications such as LLM, SD, Machine learning, NLP, Computer Vision, Robotics, Expert Systems, Speech Recognition, Virtual Agents and Chatbots, and Recommender Systems.",
    //     image: require("../../assets/images/sponsors/norbert.png")
    // },
    {
        name: "IOBC Capital",
        link: "https://www.iobc.capital/#/",
        description: "IOBC Capital is a global crypto venture capital fund that's on a mission to revolutionize the blockchain landscape. Born in 2021, their goal is to give early-stage crypto projects the kickstart they need to take over the world, while pushing the boundaries of the web3 industry.",
        image: require("../../assets/images/sponsors/iobc.jpeg")
    },
    {
        name: "Nascentcore",
        link: "https://nascentcore.ai/",
        description: "Nascentcore represents the new era of distributed GenAI computing platforms. The platform boasts cutting-edge heterogeneous GPU technology, efficient cluster scheduling management, and robust capabilities for training large models. Furthermore, Nascentcore is poised to become the next-gen titan of GenAI cloud services platform.",
        image: require("../../assets/images/sponsors/nascentcore.png")
    },
    {
        name: "Puffer Finance",
        link: "https://www.puffer.fi/",
        description: "Puffer Finance is a liquid staking protocol on Eigenlayer, focused on enhancing Ethereum's decentralization. It strengthens Ethereum by creating a robust decentralized pocket within the validator network, making home-staking highly viable.",
        image: require("../../assets/images/sponsors/puffer.png")
    },
    {
        name: "Brix Labs",
        link: "https://en.joinbrix.com/",
        description: "Brix Labs specializes in simplifying global tech team-building through an automated screening, recruiting, and management system. With a network of over 5,000 software engineers who have undergone rigorous 3-hour interviews, Brix Labs has established a robust infrastructure to support the entire hiring and management lifecycle.",
        image: require("../../assets/images/sponsors/brix.png")
    },
    {
        name: "RNS ID",
        link: "https://rns.id/",
        description: "The Palau Digital Residency Program offers global citizens the ability to have a legal government-issued ID from the comfort of their home, with both a physical ID card and a digitalized ID for connected services.",
        image: require("../../assets/images/sponsors/rns.svg").default
    },
    {
        name: "PingCAP",
        link: "https://www.pingcap.com/",
        description: "The mission of PingCAP is to empower engineers and enterprises to innovate with speed, agility, and scale. With the help of hundreds of global contributors, PingCAP is building TiDB, an advanced, open source, distributed SQL database with MySQL compatibility. TiDB is one of the most popular open-source database projects in the world. Additionally, TiKV, TiDB’s unique Key-Value storage layer, is a CNCF Graduated project.",
        image: require("../../assets/images/sponsors/pingcap.png")
    },
    {
        name: "AIVRES",
        link: "https://aivres.com/",
        description: "AIVRES is a data center servers and storage solutions provider committed to delivering innovative technologies that propel the world’s leading industries to new frontiers. AIVRES widely deliver and deploy cutting-edge hardware products and designs to major data centers across the US, supporting critical modern applications that include cloud, AI, big data, mass storage, and edge. Their unique JDM model enables open collaboration with partners and customers to develop purpose-built, performance-optimized solutions that tackle different workloads and overcome real-world challenges.",
        image: require("../../assets/images/sponsors/aivres.webp")
    },
    {
        name: "Wagmi33 Foundation",
        link: "https://www.wagmi33.org/",
        description: "Wagmi33 Foundation is a private equity investment DAO governed by decentralized principles. The mission of Wagmi33 is to discover the best teams and innovations in Web3 related areas. It provides capital investment and comprehensive incubator services and aims to become the decentralized evolution of Y Cominator in the era of Web3.",
        image: require("../../assets/images/sponsors/wagmi.png")
    },
    {
        name: "Yiren Digital",
        link: "https://ir.yirendai.com/",
        description: "",
        image: require("../../assets/images/sponsors/yiren.png")
    },
    {
        name: "Aligns.ai",
        link: "https://aligns.ai/",
        description: "",
        image: require("../../assets/images/sponsors/aligns.png")
    },
    
    {
        name: "Petoi",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/Petoi1.png")
    },
    {
        name: "Agent2",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/agent2.png")
    },
    {
        name: "pulze",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/pulze.png")
    },
    {
        name: "zipstack",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/Zipstack.png")
    },
    {
        name: "onecarmel",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/onecarmel.png")
    },
    {
        name: "K&L",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/K&L.png")
    },
    {
        name: "BrilinkerGPT",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/brilinker.png")
    },
    {
        name: "Realloop",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/realloop.png")
    },
    {
        name: "Express",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/xpress1.png")
    },
    {
        name: "faceAI",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/faceAI.png")
    },
    {
        name: "formacloud",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/formacloud1.png")
    },
    {
        name: "porkey",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/portkey.png")
    },
    {
        name: "Iris Energy",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/irisenergy.png")
    },
    {
        name: "MetaStill",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/metastill.png")
    },
    {
        name: "MathGPT",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/MathGPT.png")
    },
    {
        name: "BoxNearBy",
        link: "",
        description: "",
        image: require("../../assets/images/sponsors/boxnearby.png")
    },
]
